<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Serious Adverse Events
      </h2>
      <p class="tw-italic tw-text-gray-700">
      </p>
    </b-container>

    <br />

    <div style="width: 100%; overflow: auto;">
      <b-table
        striped
        hover
        sticky-header="70vh"
        :items="data"
        :fields="fields"
      />
    </div>

    <b-alert v-if="loading" variant="info" show>Loading... <i class="fas fa-spin fa-spinner"></i></b-alert>

  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

export default {
  mixins: [DashboardBaseTemplate],
  data() {
    return {
      loading: false,
      csvLoading: false,
      loadingError: false,
      csvLoadingError: false,
      // set label for display header
      fields: [
        'date_of_visit',
        'ae_sae_date',
        'member_id',
        'ae_sae_id',
        'household_id',
        'subject_withdrawn',
        'ae_sae_diagnosis',
        'hospitalization_admission_date'
      ],
      data: [],
    };
  },
  mounted: function() {
    const that = this;
    that.loading = true;
    // generalized data request
    HTTP.get('/eavetubes/serious-adverse-events/'
    ).then((response) => {
      that.loading = false;
      that.data = response.data.data;
    }).catch((error) => {
      that.loading = false;
      that.loadingError = true;
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {},
};
</script>

<style>
.buffer-20{
  margin-right: 20px;
  margin-bottom: 20px;
}
</style>
